// Copyright 2018-2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import DeploymentForm from "./DeploymentForm";

export default DeploymentForm;
